import {
  CONNECTOR_FEATURE_REVIEWS,
  hasReviewsConnector,
  useConnectors,
} from "@/api/connectors";
import { createSiteAllowlistFlagFromVar } from "@/utils/siteAllowlistFlag";

/**
 * Average rating / review count authoring (FOG-2692), rolled out per site.
 * `VITE_FF_REVIEW_RATING_SITES` holds a comma-separated list of site ids, or
 * `true` to enable everywhere. Authoring only: saved tags and grids keep
 * exporting whether or not the flag is on.
 */
const reviewRatingSiteCheck = createSiteAllowlistFlagFromVar(
  import.meta.env.VITE_FF_REVIEW_RATING_SITES,
);

export const isReviewRatingEnabled = (siteId: string | undefined) =>
  reviewRatingSiteCheck(siteId);

/**
 * Whether the rating tags and the grid's Rating field can be authored on this
 * site: it's allowlisted and has a reviews connector, the same check the
 * grid's Enable reviews trait makes. The connector lookup only runs on
 * allowlisted sites.
 */
export function useReviewRatingsAvailable(siteId: string | undefined): boolean {
  const enabled = isReviewRatingEnabled(siteId);
  const { data: connectors } = useConnectors(
    enabled ? (siteId ?? "") : "",
    CONNECTOR_FEATURE_REVIEWS,
  );
  return enabled && !!connectors && hasReviewsConnector(connectors);
}
